export const GET_CATEGORY_LIST_REQUEST = "get_category_list_request";
export const GET_CATEGORY_LIST_RESPONSE = "get_category_list_response";

export const GET_CHILD_CATEGORY_LIST_REQUEST =
  "get_child_category_list_request";
export const GET_CHILD_CATEGORY_LIST_RESPONSE =
  "get_child_category_list_response";

export const GET_CATEGORY_LIST_FOR_SUB_CATEGORY_REQUEST =
  "get_category_list_for_sub_category_request";
export const GET_CATEGORY_LIST_FOR_SUB_CATEGORY_RESPONSE =
  "get_category_list_for_sub_category_response";

export const GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_REQUEST =
  "get_category_list_for_product_category_request";
export const GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_RESPONSE =
  "get_category_list_for_product_category_response";

export const ADD_CATEGORY_REQUEST = "add_category_request";
export const ADD_CATEGORY_RESPONSE = "add_category_response";

export const UPDATE_CATEGORY_BY_CATEGORY_ID_REQUEST =
  "update_category_by_category_id_request";
export const UPDATE_CATEGORY_BY_CATEGORY_ID_RESPONSE =
  "update_category_by_category_id_response";

export const DELETE_CATEGORY_BY_CATEGORY_ID_REQUEST =
  "delete_category_by_category_id_request";
export const DELETE_CATEGORY_BY_CATEGORY_ID_RESPONSE =
  "delete_category_by_category_id_response";

export const UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_REQUEST =
  "update_category_status_by_category_id_request";
export const UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_RESPONSE =
  "update_category_status_by_category_id_response";
